export const environment = {
    apiUrl: 'https://localhost:7180',
};
